import React, { VFC } from 'react';
import { CreditCardType } from '../../organisms/CreditCard/types';

import { LOGOS } from './constants';

export type Props = {
  type: CreditCardType;
  width?: number;
  height?: number;
};

const Logo = ({ type, width, height }: Props) => {
  const Logo: VFC<Omit<Props, 'type'> & { id?: string }> = LOGOS[type];

  if (Logo) return <Logo width={width} height={height} id={type} />;
  return null;
};

export default Logo;
